import type { VersionedWording } from '@/lib/versioned-labels';

/**
 * How the versioned layer names an NPC, everywhere it has to (npc.md, issue #210).
 *
 * The twin of `persona-wording.tsx`, and a copy rather than a template for the reason that file
 * gives: French agreement is not a concatenation. Two things are NEW compared with the four older
 * objects:
 *
 *   - `developmentOnly` - the NPC has one side, development (N5): the layer draws no production
 *     anywhere (see `VersionedWording.developmentOnly`);
 *   - the retirement speaks of LAUNCHES and BENCHES, not of references: nothing cites an NPC, and
 *     what « Retirer » changes is who may pick it (§3.5, H24).
 *
 * Two `data-testid` prefixes, accent-free: `npc-carte`, `npcs-grille` - the same word in the
 * plural, since « NPC » is invariable on screen (H1) and the two prefixes would otherwise collide.
 */
export const NPC_WORDING: VersionedWording = {
  kind: 'npc',
  developmentOnly: true,
  entity: 'npc',
  list: 'npcs',
  noun: ['NPC', 'NPC'],
  newTitle: 'Nouveau NPC',
  saveHintNew:
    'Actif dès que le nom, le prénom, « Qui c’est », « Comment jouer » et une source sont remplis.',
  draftStateNew: 'Aucune version encore. Le premier enregistrement écrit la v1.',
  createLabel: 'Créer un nouveau NPC',
  developmentHint: () => 'Un NPC n’est joué que par des rejeux, et ne change aucun rejeu passé.',
  subject: (name) => `NPC « ${name} »`,
  retirement: {
    panelTitle: 'Retirer ce NPC',
    retiredTitle: 'NPC retiré',
    confirmLabel: 'Retirer le NPC',
    panelHint: () => (
      <>
        Il n’est plus proposé au lancement ni dans les bancs ; ses rejeux et ses versions restent.
        Restauration possible depuis l’historique.
      </>
    ),
    retiredHint: (_name, day) => (
      <>
        Retiré le {day}. Il n’est plus proposé au lancement ni au choix des bancs ; les bancs qui le
        portaient le gardent et leur lancement le saute. Ses rejeux restent lisibles.
      </>
    ),
    warningTitle: (name) => `Les bancs qui portent « ${name} » le sauteront au lancement`,
  },
  refusal: {
    nameTaken: 'Ce nom est déjà porté par un autre NPC. Choisissez-en un autre.',
    nameTakenBy: (name) =>
      `« ${name} » porte déjà ce nom. Choisissez-en un autre, ou renommez d’abord l’autre NPC.`,
    retired: 'Ce NPC est retiré. Restaurez-le avant de le modifier.',
  },
};
